/**
 * The dock's home — spec §F6: "home = intro line (+ AOI-active note) + 6 tool cards (icon
 * tile colour per Part H) + 'Clear result layers (n)'". Buffer and overlay left the dock in
 * Task 10 (client items 11/12) — a UI-only removal, so their §D6 endpoints stay live.
 *
 * The intro is the mockup's, minus its last sentence ("This mockup simulates each run on
 * the demo data"), which is no longer true: the runs are real, and the sentence would now
 * be the one false claim on the page.
 *
 * "Clear result layers (n)" is the same action as the §F5.6 block's own ✕
 * (`clearResultLayers`), and the count comes from the store rather than from anything this
 * component holds — the legend can clear them too, and two counters would disagree.
 */
import { useTranslation } from 'react-i18next';

import { TOOLS, type ToolId } from '../../lib/analysis';
import { fmtKm2 } from '../../lib/format';
import { useAppStore } from '../../lib/state';
import { ToolCard } from './ToolCard';

export interface ToolHomeProps {
  onOpen: (id: ToolId) => void;
}

export function ToolHome({ onOpen }: ToolHomeProps) {
  const { t } = useTranslation();
  const aoi = useAppStore((s) => s.aoi);
  const results = useAppStore((s) => s.results);
  const clearResultLayers = useAppStore((s) => s.clearResultLayers);

  return (
    <>
      <div id="adIntro">
        {t('analysis.intro')}
        {aoi ? (
          <div className="note" style={{ marginTop: 8 }} data-note="aoi">
            {t('analysis.aoiActive', { area: fmtKm2(aoi.areaKm2) })}
          </div>
        ) : null}
      </div>
      {TOOLS.map((card) => (
        <ToolCard key={card.id} card={card} onOpen={onOpen} />
      ))}
      {results.length ? (
        <div className="ad-clear">
          <button type="button" className="btn ghost sm" id="clearRes" onClick={clearResultLayers}>
            {t('analysis.clearResults', { count: results.length })}
          </button>
        </div>
      ) : null}
    </>
  );
}

export default ToolHome;
